module.exports = __webpack_public_path__ + "img/15.17d6d546.svg";